import Typography from '@mui/material/Typography';

export function ExampleModal() {
  return <Typography>Example Modal</Typography>;
}
